import styled from 'styled-components';

export type SectionTone = 'base' | 'raised';

const Section = styled.section<{ $tone?: SectionTone; $flushTop?: boolean }>`
  position: relative;
  padding: ${({ $flushTop }) => ($flushTop ? '0' : 'var(--section-y)')} 0 var(--section-y);
  background-color: ${({ $tone }) => ($tone === 'raised' ? 'var(--bg-1)' : 'var(--bg-0)')};
  border-top: ${({ $flushTop }) => ($flushTop ? '0' : '1px solid var(--border)')};
`;

export default Section;
